import React from 'react';
import PropTypes from 'prop-types';
import { Block, Page } from 'framework7-react';
import { DOC_TYPE_DOCUMENT } from '../helpers/utils';
import DesktopDocEntry from './DesktopDocEntry';
import II18 from '../translate/II18';
import {
  ExpiredWarningBlock,
  ListHeaderBlock,
  SendButtonBlock,
  SuccessMessageBlock
} from './Elements';

import { gaClickOnDocType, gaeList, gaListPageView } from './ga';
import DesktopMainPage from '../desktop/DesktopMainPage';
import withDesktopUpload from '../helpers/withDesktopUpload';
import DesktopThankyouPopUp from './DesktopThankyouPopUp';

class DesktopDocumentsList extends React.Component {
  onPageIn = () => {
    gaListPageView();
  };

  loadDesktopImage(document) {
    gaeList('START_FILE_UPLOAD');
    this.props.loadFromFile(document.id, () =>
      this.openDesktopGallery(document)
    );
  }

  openDesktopGallery = document => {
    gaeList('DOCUMENT_PAGES_POPUP', 'SHOW', true);
    this.props.navigateToDesktopDocument(document);
  };

  onDocumentOpenClick = document => {
    switch (document.type) {
      case DOC_TYPE_DOCUMENT:
        gaClickOnDocType(document.type, document.id.substring(0, 4));
        this.openDesktopGallery(document);
        /*if (document.done) {
          this.openDesktopGallery(document);
        } else {
          !readOnlyEntry && this.loadDesktopImage(document);
        }*/
        break;
      default:
        this.props.navigateToDesktopDocument(document);
    }
  };

  render = () => {
    const {
      expired,
      scanEnded,
      forms,
      documentsStatus,
      successSentKeys,
      errorSentKeys,
      templateMode,
      privacyAccepted,
      setPrivacyAccepted,
      currentActionForDocType,
      requestedDocuments,
      isDocumentsReadyToSend,
      actionDocument,
      onlyInfoDocuments,
      haveDocumentsToSend,
      removeCurrentActionDocument,
      showThankyouPopUp,
      onCloseThankYouPopup,
      companyName,
      onSendRequest,
      usersDataOk,
      infoMessage,
      errorMessage,
      completeButtonLabel
    } = this.props;

    const docsToShow = requestedDocuments.filter(
      doc => !(doc.optional && scanEnded) || doc.done
    );

    return (
      <Page
        onPageBeforeIn={this.onPageIn}
        onPageAfterIn={this.onPageAfterIn}
        id={'desktopDocumentsList'}
      >
        <DesktopMainPage
          actionDocument={actionDocument}
          popupId={currentActionForDocType}
          onPopupClose={removeCurrentActionDocument}
          pageContent={
            <>
              {showThankyouPopUp && (
                <DesktopThankyouPopUp
                  onClosePopUp={onCloseThankYouPopup}
                  companyName={companyName}
                />
              )}
              {requestedDocuments && requestedDocuments.length ? (
                <div>
                  <ListHeaderBlock
                    onlyInfoDocuments={onlyInfoDocuments}
                    scanEnded={scanEnded}
                    expired={expired}
                  />

                  <div
                    className={'tinny-scrollbar'}
                    style={{
                      maxHeight: '50vh',
                      overflow: 'auto',
                      position: 'relative',
                      height: 'auto'
                    }}
                  >
                    {docsToShow.map(document => (
                      <DesktopDocEntry
                        key={document.id}
                        document={document}
                        scannedPages={this.props.getScannedPages(document.id)}
                        forms={forms}
                        documentsStatus={documentsStatus}
                        onDesktopUploadClick={this.onDocumentOpenClick}
                        scanEnded={scanEnded}
                        successSentKeys={successSentKeys}
                        errorSentKeys={errorSentKeys}
                      />
                    ))}
                  </div>

                  {(!onlyInfoDocuments || scanEnded) &&
                    (scanEnded ? (
                      <div>
                        {expired ? (
                          <ExpiredWarningBlock />
                        ) : (
                          <SuccessMessageBlock
                            submittedDate={this.props.submittedDate}
                          />
                        )}
                      </div>
                    ) : (
                      <SendButtonBlock
                        privacyAccepted={privacyAccepted}
                        onPrivacyClick={() =>
                          setPrivacyAccepted(!privacyAccepted)
                        }
                        desktop={window.isDesktop}
                        templateMode={templateMode}
                        haveDocumentsToSend={haveDocumentsToSend}
                        allRequiredOk={isDocumentsReadyToSend}
                        usersDataOk={usersDataOk}
                        completeButtonLabel={completeButtonLabel}
                        onClick={() => {
                          onSendRequest();
                        }}
                      />
                    ))}
                </div>
              ) : (
                <div>
                  <Block>
                    <p
                      data-testid="requestInProcessMessage"
                      style={{ textAlign: 'center' }}
                    >
                      <II18>list_request_processing</II18>
                    </p>
                  </Block>
                  <Block id={'infoMessage'} style={{ textAlign: 'center' }}>
                    {infoMessage && (
                      <span style={{ color: 'blue' }}>{infoMessage}</span>
                    )}
                  </Block>

                  <Block id={'errorMessage'} style={{ textAlign: 'center' }}>
                    {errorMessage && (
                      <span style={{ color: 'red' }}>{errorMessage}</span>
                    )}
                  </Block>
                </div>
              )}
            </>
          }
        />
      </Page>
    );
  };
}

DesktopDocumentsList.propTypes = {
  infoMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  usersDataOk: PropTypes.bool,
  isDocumentsReadyToSend: PropTypes.bool,
  actionDocument: PropTypes.object,
  onlyInfoDocuments: PropTypes.bool,
  haveDocumentsToSend: PropTypes.bool,
  documentsStatus: PropTypes.object,
  expired: PropTypes.bool,
  forms: PropTypes.object,
  privacyAccepted: PropTypes.bool,
  scanEnded: PropTypes.bool,
  setPrivacyAccepted: PropTypes.func,
  submittedDate: PropTypes.string,
  successSentKeys: PropTypes.object,
  errorSentKeys: PropTypes.object,
  templateMode: PropTypes.bool,
  requestedDocuments: PropTypes.array,
  getScannedPages: PropTypes.func,
  currentActionForDocType: PropTypes.string,
  showThankyouPopUp: PropTypes.bool,
  onCloseThankYouPopup: PropTypes.func,
  companyName: PropTypes.string,
  componentId: PropTypes.string,
  completeButtonLabel: PropTypes.string,

  //withDesktopUpload
  loadFromFile: PropTypes.func,

  //withDocumentRootLogic
  navigateToDesktopDocument: PropTypes.func,
  removeCurrentActionDocument: PropTypes.func,

  // send request
  onSendRequest: PropTypes.func
};

export default withDesktopUpload(DesktopDocumentsList);
